<rl-list-item-placeholder
  *ngIf="!item"
  [itemId]="itemId"
></rl-list-item-placeholder>

<article
  *ngIf="item?.id ? true : false"
  [class.is-expanded]="isExpanded"
  class="c-list-item"
  [id]="itemElementId"
  [attr.aria-label]="itemAriaLabel"
>
  <ng-container *ngIf="item.resource && resourceImage">
    <div
      class="c-list-item__thumbnail-container qa-toggle-collapse"
      [class.is-expanded]="isExpanded"
      (click)="onToggle()"
      role="presentation"
    >
      <img
        alt=""
        draggable="false"
        class="c-list-item__thumbnail t-brand-background-color qa-item__thumbnail"
        [class.is-expanded]="isExpanded"
        [src]="resourceImage"
        (load)="onImageLoaded()"
      />
    </div>
  </ng-container>

  <div class="c-list-item__content">
    <div *ngIf="item.resource" class="c-list-item__content--info">
      <header
        [ngSwitch]="item.resource.isNonPageResource() && showCitation"
        class="c-list-item__meta"
      >
        <div role="heading" [attr.aria-level]="itemHeadingLevel">
          <rl-item-citation
            *ngSwitchCase="true"
            [citation]="currentCitation"
            [item]="item"
            [listId]="listId"
            [isExpanded]="isExpanded"
            (itemClicked)="onToggle()"
          >
          </rl-item-citation>

          <rl-course-reserve-status [item]="item"></rl-course-reserve-status>

          <rl-fielded-resource
            *ngSwitchDefault
            [resource]="item.resource"
            [itemImportance]="item.importance"
            [listId]="listId"
            ariaControlsId="item_{{ item.id }}_detail"
            [isClickable]="true"
            [isExpanded]="isExpanded"
            (resourceClicked)="onToggle()"
          >
          </rl-fielded-resource>
        </div>
      </header>
      <div
        *ngIf="item.resource.isNonPageResource()"
        class="c-list-item__action-group qa-item__status"
      >
        <rl-online-resource-button
          *ngIf="showViewOnlineButton"
          class="u-mr2"
          [itemElementId]="itemElementId"
          [onlineResource]="onlineResource"
          (onlineResourceClick)="onOnlineResourceClick($event)"
        >
        </rl-online-resource-button>
        <button
          *ngIf="showAvailabilityButton"
          type="button"
          class="btn btn-xs btn-default qa-view-item-component__view-availability"
          i18n="@@viewItemComponent-btn-viewAvailability"
          (click)="onToggle()"
          [attr.aria-describedby]="itemElementId"
        >
          View Availability
        </button>

        <div class="c-list-item__action-group__buttons">
          <rl-reading-intentions-menu
            [resourceId]="item.resource.id"
            [readingIntention]="readingIntention"
            [areAnnotationsResolved]="areAnnotationsResolved"
            (readingIntentionDelete)="onReadingIntentionDelete($event)"
            (readingIntentionUpdate)="onReadingIntentionUpdate($event)"
          >
          </rl-reading-intentions-menu>

          <rl-view-item-menu
            [itemId]="item.id"
            [resourceId]="item.resource.id"
            [areAnnotationsResolved]="areAnnotationsResolved"
            [studyNote]="studyNote"
            [permissions]="currentUserPermissions"
            [isSubscribedToResource]="isSubscribedToResource"
            (studyNoteEdit)="onStudyNoteEdit()"
            (addToMyBookmarks)="onAddToMyBookmarks($event)"
            (citationExport)="onCitationExport($event)"
            (toggleMenu)="onCheckResourceSubscription($event)"
            (shareItem)="onShareItem()"
            (reportBrokenLink)="onShowReportBrokenLinkModal()"
            class="c-list-item__actions"
          >
          </rl-view-item-menu>
        </div>
      </div>
    </div>

    <div
      *ngIf="!item.resource && item.student_note ? true : false"
      class="c-list-item__note c-list-item__note--standalone"
    >
      <span [innerHTML]="item.student_note | autoLinkUrl"></span>
    </div>

    <div
      class="c-list-item__note c-list-item__note--student"
      *ngIf="item.resource && item.student_note ? true : false"
    >
      <rl-inline-note
        [noteType]="InlineNoteEditorType.FOR_STUDENTS"
        [note]="item.student_note"
      >
      </rl-inline-note>
    </div>

    <rl-study-note
      #studyNoteComponent
      *ngIf="
        item.resource &&
        areAnnotationsResolved &&
        (studyNote || studyNoteMode === StudyNoteMode.CREATE)
      "
      [resourceId]="item.resource.id"
      [studyNote]="studyNote"
      [mode]="studyNoteMode"
      [user]="user"
      (update)="onStudyNoteUpdate($event)"
      (cancel)="onStudyNoteReset()"
      (delete)="onStudyNoteDelete($event)"
    >
    </rl-study-note>

    <div
      *ngIf="item.resource"
      [collapse]="!isExpanded"
      id="item_{{ item.id }}_detail"
      class="row c-list-item__detail"
    >
      <!-- Bibliographic resources should expand to show metadata and availability -->
      <section
        class="c-list-item__availability col-xs-12"
        *ngIf="isExpanded && item.resource.isNonPageResource()"
      >
        <div class="row">
          <rl-resource-availability
            [depth]="depth"
            [resource]="item.resource"
            [item]="item"
            [onlineResource]="onlineResource"
            [overrideDefaultOnlineResource]="item.defaultOnlineResource"
            (onlineResourceClick)="onOnlineResourceClick($event)"
            class="col-xs-12 col-md-6 u-flex-fix"
          >
          </rl-resource-availability>
          <rl-item-metadata
            [depth]="depth"
            [resource]="item.resource"
            class="col-xs-12 col-md-6 u-flex-fix"
          >
          </rl-item-metadata>
        </div>
      </section>

      <!-- Page resources should expand to show only the page content -->
      <rl-page-content
        *ngIf="isExpanded && item.resource.isPageResource() && pageContent"
        [pageContent]="pageContent"
        class="list__item__col--content col-xs-12 qa-page-content"
      >
      </rl-page-content>
    </div>
  </div>
</article>
